import { Typography } from "@suraasa/placebo-ui"
import PageContainer from "components/PageContainer"
import { CountdownCircleTimer } from "react-countdown-circle-timer"
import useHideGlobalBottomNavigation from "utils/hooks/useGlobalHideBottomNavigation"
import useHideTopNavigation from "utils/hooks/useHideTopNavigation"

const PaymentUnderProcess = ({ onComplete }: { onComplete: () => void }) => {
  useHideGlobalBottomNavigation()
  useHideTopNavigation()
  return (
    <PageContainer className="flex h-screen flex-col items-center justify-center gap-4 py-2">
      <div className="flex justify-center">
        <CountdownCircleTimer
          isPlaying
          duration={5 * 60}
          colors={["#3852C5", "#3852C5"]}
          colorsTime={[0, 1]}
          strokeWidth={10}
          onComplete={() => {
            onComplete()
          }}
        >
          {({ remainingTime }) => {
            const minutes = Math.floor(remainingTime / 60)
            const seconds = (remainingTime % 60).toString().padStart(2, "0")
            return (
              <div className="flex flex-col items-center justify-center">
                <Typography variant="largeBody">
                  {minutes}:{seconds}
                </Typography>
              </div>
            )
          }}
        </CountdownCircleTimer>
      </div>
      <Typography variant={"title3"} className="mb-1 mt-2 text-center">
        Payment Under Process
      </Typography>
      <Typography
        variant={"largeBody"}
        className="text-center text-onSurface-500"
      >
        We’re processing your payment. This might take a while. Please don’t
        refresh or close this page.
      </Typography>
    </PageContainer>
  )
}

export default PaymentUnderProcess
